import { createContext } from "react";
const noteContext = createContext<any>({});
export default noteContext;
